(function () {
    'use strict';

    angular.module('app').factory('StatisticsService', StatisticsService);

    StatisticsService.$inject = ['$rootScope', 'API', '$filter', 'NotifyService'];

    function StatisticsService($rootScope, API, $filter, NotifyService) {
        var service = {};

        var _req_gc = ['STATISTICS'];
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */

        initVars();

        function initVars() {
            for (var i in _req_gc) $rootScope[_req_gc[i]] = {};
        }

        $rootScope.$on('user-login', function () {
            initVars();
        });

        $rootScope.$on('user-register', function () {
            initVars();
        });

        $rootScope.$on('user-logout', function () {
            for (var i in _req_gc) $rootScope[_req_gc[i]] = null;
        });

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.TopTurnover = function (params, callback) {
            API.post('/analytics/turnover/top', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.turnover = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CorporateTopTurnover = function (params, callback) {
            API.post('/analytics/corporate_customers/turnover/top', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.corporate_turnover = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.TopVisits = function (params, callback) {
            API.post('/analytics/visits/top', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.visits = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CorporateTopVisits = function (params, callback) {
            API.post('/analytics/corporate_customers/visits/top', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.corporate_visits = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.VisitsByTime = function (params, callback) {
            API.post('/analytics/visits/bytime', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.visits_by_time = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.TurnoverByTime = function (params, callback) {
            API.post('/analytics/turnover/bypos/bytime', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.visits_by_time = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.TurnoverByPOS = function (params, callback) {
            API.post('/analytics/turnover/bypos', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.turnover_by_pos = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.VisitsByPOS = function (params, callback) {
            API.post('/analytics/visits/bytime/bypos', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.visits_by_pos = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.RedeemByPOS = function (params, callback) {
            API.post('/analytics/bonuses/redeemed/bypos', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.redeemed_by_pos = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.Bonuses = function (params, callback) {
            API.post('/analytics/bonuses', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.bonuses = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.SegmentsDynamics = function (params, callback) {
            API.post('/analytics/customers/segments/dynamics', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.segments_dynamics = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CorporateSegmentsDynamics = function (params, callback) {
            API.post('/analytics/corporate_customers/segments/dynamics', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.corporate_segments_dynamics = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UsingApp = function (params, callback) {
            API.post('/analytics/customers/mobileapps', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.using_app = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyItemsUsagePosSummary = function (params, callback) {
            API.post('/analytics/loyalty_items/usage/pos/summary', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.usage_pos_summary = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyItemsUsageSummary = function (params, callback) {
            API.post('/analytics/loyalty_items/usage/summary', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.usage_summary = response;
                }
                callback(success, response);
            });
        };

        /**
         *
         * @param params
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.LoyaltyItemsUsageTerminalSummary = function (params, callback) {
            API.post('/analytics/loyalty_items/usage/terminal/summary', params, function (success, response) {
                if (success) {
                    $rootScope.STATISTICS.usage_terminal_summary = response;
                }
                callback(success, response);
            });
        };

        return service;
    }

})();
